// Generated by https?://quicktype.io

import { UserLinked } from '@eightcap/core';
import { TransferBaseModel } from '../transfer-base.model';

export interface TradingAccount extends TransferBaseModel {
    id?: string;
    trading_account_number?: string;
    platform_lookup?: string;
    users_linked?: any[];
    name?: string;
    balance?: number;
    open_date?: Date;
    close_date?: Date;
    currency_lookup?: string;
    trading_group?: string;
    trading_account_type_lookup?: string;
    leverage_lookup?: string;
    auto_leverage?: boolean;
    enabled?: boolean;
    margin?: number;
    margin_free?: number;
    margin_level?: number;
    account_linked?: string;
    processing_state_lookup?: string;
    trading_account_status_lookup?: null;
    read_only?: boolean;
    credit?: string;
    free_balance?: number;
    send_reports?: boolean;
    crm_id?: string;
    withdrawal?: number;
    last_deposit_date?: Date;
    last_trade_date?: Date;
    finance?: Finance;
    created_date?: Date;
    change_password_enabled?: boolean;
    transfer_to_disabled?: boolean;
    transfer_from_disabled?: boolean;
    agent_number?: string;
    archived?: boolean;
    overridden?: boolean;
    trading_account_product?: string;
    receive_rebate_transfers?: boolean;
    users_unlink?: UserLinked[];
    account_unlink?: string;
}

export interface Finance {
    rebate?: string;
    profit?: string;
    trade_volume?: string;
}

// export enum PlatformLookup {
//     MT4L = 'MT4-L',
//     MT4D = 'MT4-D',
//     MT5L = 'MT5-L',
//     MT5D = 'MT5-D',
//     MT4ROWL = 'MT4-ROW-L',
//     MT4ROWD = 'MT4-ROW-D',

//     //Focus markets
//     MT5L_FCS = 'MT5-FCS-L',
//     MT5D_FCS = 'MT5-FCS-D',
//     //Blueberry
//     MT4_BBL = 'MT4-BB-L',
//     MT4_BBD = 'MT4-BB-D',
// }

/**
 * See lookup/LOOKUP_TRADING_ACCOUNT_TYPE
 */
export enum TradingAccountType {
    Raw = 'RAW',
    Standard = 'STD',
    MAM_Master = 'MAMM',
    MAM_Slave = 'MAMS',
    Rebate = 'RBT'
}

export enum CustomerRiskScore {
    Pass = 'Pass',
    PassWithWarning = 'PW',
    WARNINGandManualReview = 'WR',
    Fail = 'Fail',
    Refer = 'Refer',
    UnKnown = 'UNKNOWN'
}

export enum TradingAccountPlan {
    DEMO,
    LIVE,
    UnKnown
}
